import { render } from "./GoalActivity.vue?vue&type=template&id=16dbbd8e"
import script from "./GoalActivity.vue?vue&type=script&lang=js"
export * from "./GoalActivity.vue?vue&type=script&lang=js"
script.render = render

export default script